const toMinutes = (hhmm: string) => {
  const [h, m] = hhmm.split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return h * 60 + m;
};

const toHHMM = (mins: number) => {
  const normalized = mins % (24 * 60); // wrap back into 0–1439
  const h = Math.floor(normalized / 60);
  const m = normalized % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const getLastEntryOptions = (workingFrom: string, workingTo: string) => {
  const fromMin = toMinutes(workingFrom || '');
  let toMin = toMinutes(workingTo || '');
  if (fromMin == null || toMin == null) return [];

  if (toMin <= fromMin) {
    toMin += 24 * 60;
  }

  const end = toMin - 60; // last entry 1 hour before closing
  if (end < fromMin) return [];

  const step = 15;
  const opts: { value: string; label: string }[] = [];

  for (let t = fromMin; t <= end; t += step) {
    const v = toHHMM(t);
    opts.push({ value: v, label: v });
  }

  return opts;
};
